import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'money'
})
export class MoneyPipe implements PipeTransform {

  currencyCodes = {
    'EUR': '€',
    'DOLLAR': '$'
  }

  constructor(private decimalPipe: DecimalPipe) {
  }

  transform(value: any, args: any, param: any): any {
    const currencySymbol = this.currencyCodes[param];
    let price = '';

    if (_.isNil(value) || value == '') {
      return '';
    }

    if (_.isNil(currencySymbol)) {
      price = `${this.decimalPipe.transform(value, '0.2-2')}`;
    } else {
      price = `${this.decimalPipe.transform(value, '0.2-2')} ${currencySymbol}`;
    }

    if (!_.isNil(args) && !_.isNil(args.compactFormat) && args.compactFormat === true) {
      return price.replace(/\s/g, '').replace(',', '.');
    }
    return price;
  }
}
